function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_179",
  "data-name": "Rectangle 179",
  width: 20,
  height: 20,
  transform: "translate(0 0)",
  fill: "#0078d7",
  stroke: "#adacac",
  strokeWidth: 1
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_3375",
  "data-name": "Group 3375",
  transform: "translate(0 0.115)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_336",
  "data-name": "Group 336",
  transform: "translate(0 -0.115)",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_179",
  "data-name": "Path 179",
  d: "M17.665,1.774a2.748,2.748,0,0,0-3.883,0l-.972.977L2.462,13.094l-.022.022c-.005.005-.005.011-.011.011-.011.016-.027.033-.038.049s-.006.005-.006.011-.016.027-.027.044-.005.011-.011.016-.011.027-.017.044-.005.005-.005.011l-2.3,6.9a.541.541,0,0,0,.132.56.553.553,0,0,0,.39.159A.65.65,0,0,0,.727,20.9l6.9-2.3c.005,0,.005,0,.011-.005a.2.2,0,0,0,.049-.022.019.019,0,0,0,.011-.005c.016-.011.038-.022.055-.033s.033-.027.049-.038.011-.006.011-.011.017-.011.022-.022L19.153,7.14a2.748,2.748,0,0,0,0-3.883ZM7.449,17.306,3.627,13.484l9.568-9.568,3.823,3.822ZM3.088,14.5l3.339,3.339-5.015,1.67ZM18.379,6.371l-.582.588L13.974,3.136l.588-.588a1.647,1.647,0,0,1,2.329,0l1.494,1.494a1.653,1.653,0,0,1-.005,2.329",
  transform: "translate(0 -0.843)",
  fill: "#0078d7",
  stroke: "#adacac",
  strokeWidth: 1
})));

function SvgEditPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/edit-pencil.5a4b8333.svg";
export { ForwardRef as ReactComponent };